module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.assigned !== null) ? _c('assign', {
    attrs: {
      "titleHighlight": _vm.name,
      "title": _vm.$t('list_of_coursework_for'),
      "assigned": _vm.assigned
    },
    on: {
      "selected": _vm.getSelected,
      "remove": _vm.remove,
      "assign": _vm.assign,
      "back": function () {
        this$1.$router.push('/course-mgr')
      },
      "finish": function () {
        this$1.$router.push('/course-mgr')
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7acc8ae2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Teacher/TeachingCourseAssign.vue
// module id = 741
// module chunks = 1